import { Box, Button, Typography } from "@mui/material"

import { useDispatch } from "react-redux"
import IconBox from "../../IconBox"
import BankIcon from "../../BankIcon"
import ModalBox from "../../ModalBox"
import { useDeleteBankPermission } from "../../../api/hooks/useDeleteBankPermission"
import { DeleteBankPermissionModalProps } from "./props"
import { removeBankVariant } from "../../../store/slices/settingsSBP"
import { BankText, BoxModal, DeleteButton } from "../styled"
import { CloseButton } from "../../styled"

const DeleteBankPermissionModal = ({
  open,
  onClose,
  selectedBank,
}: DeleteBankPermissionModalProps) => {
  const dispatch = useDispatch()
  const { mutate: deleteBankPermission } = useDeleteBankPermission()

  const handleDelete = () => {
    deleteBankPermission(selectedBank.bankID)
    dispatch(removeBankVariant(selectedBank.bankID))
    onClose()
  }

  return (
    <ModalBox open={open} onClose={onClose}>
      <Box sx={BoxModal}>
        <IconBox>
          <BankIcon logoUrl={selectedBank.bankIcon} size={30} />
        </IconBox>
        <Typography sx={BankText}>{selectedBank.bankName}</Typography>
        <Button onClick={handleDelete} sx={DeleteButton} variant="contained">
          Удалить банк
        </Button>
        <Button variant="text" sx={CloseButton} onClick={onClose}>
          Закрыть
        </Button>
      </Box>
    </ModalBox>
  )
}

export default DeleteBankPermissionModal
